import { MulticideProvider } from '@/modules/admin/multicide/multicide.provider';
import { Injectable } from "@angular/core";
import { Action, NgxsOnInit, Selector, State, StateContext, createSelector } from "@ngxs/store";
import { tap } from "rxjs/operators";

export class GetValidValuesAction {
  static readonly type = "[Multicide] Valid Values";
}


export interface MulticideStateModel {
  validValues: any;
}

@State<MulticideStateModel>({
  name: "multicide",
  defaults: {
    validValues: {},
  },
})
@Injectable()
export class MulticideStore implements NgxsOnInit {
  constructor(
    private multicideProvider: MulticideProvider,
  ) {}


  @Selector()
  static validValues(state: MulticideStateModel): any {
    return state.validValues;
  }

  @Action(GetValidValuesAction)
  getValidValueAction(ctx: StateContext<MulticideStateModel>) {
    return this.multicideProvider.getValidValues().pipe(
      tap((response) => {
        if (response) {
          ctx.patchState({
            validValues: response,
          });
        }
      })
    );
  }

  ngxsOnInit(ctx?: StateContext<MulticideStateModel>) {
    ctx?.dispatch(new GetValidValuesAction());
  }
}

